import React, { useEffect, useMemo, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Tab, Tabs } from "@material-ui/core";
import styled from "styled-components";
import queryString from "query-string";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { GoTriangleRight } from "react-icons/go";
import TabMaterialLog from "../../../../components/organisms/tabs-material/TabMaterialLog";
import PaginationList from "../../../../components/organisms/pagination-list/PaginationList";
import { getParentTripsCreatedByStateAPI } from "../../../../api/modules";
import CardItemOfferTravel from "../../components/molecules/CardItemOfferTravel";
import CardItemTravelBasic from "../../components/molecules/CardItemTravelBasic";

const DivParentTabs = styled.div`
  border-bottom: 1px solid #d1d0d0;
`;

const TabsStyled = styled(Tabs)`
  width: 90%;
  margin: 0px 30px;
  @media (max-width: 991px) {
    width: 100%;
    margin: 0px;
    margin-right: 10px;
  }
`;

const TabStyled = styled(Tab)`
  span {
    font-size: 18px;
    font-weight: bolder !important;
  }
`;

const ContainerList = styled.div`
  overflow-y: overlay;
  padding-right: 10px;
`;

const RowStyled = styled(Row)`
  position: relative;
  width: 100%;
  bottom: 0px;
  margin-top: 20px;
`;

const DivEmpty = styled.div`
  width: 100%;
  min-height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TAB_CONFIG = [
  { label: "Ofertas", state: "[1]", empty: "No hay viajes con ofertas" },
  { label: "Pendientes", state: "[2]", empty: "No hay viajes pendientes" },
  {
    label: "En ejecución",
    state: "[3,4]",
    empty: "No hay viajes en ejecución",
  },
  { label: "Finalizados", state: "[5]", empty: "No hay viajes finalizados" },
];

function ParentTravels() {
  const history = useHistory();
  const location = useLocation();
  const spinner = useSelector((state) => state.appReducer.isLoading);
  const [value, setValue] = useState(0);
  const [page, setPage] = useState(0);
  const numberList = 5;
  const INITIAL_STATE = {
    total: 0,
    items: [],
  };
  const [tripsData, setTripsData] = useState(INITIAL_STATE);

  const activeTab = useMemo(() => TAB_CONFIG[value] || TAB_CONFIG[0], [value]);

  useEffect(() => {
    const { state } = queryString.parse(location.search);
    setValue(Number(state || 0));
  }, [location.search]);

  useEffect(() => {
    fetchData(numberList, 0, activeTab.state);
    setPage(0);
  }, [activeTab.state]);

  const fetchData = async (limit = numberList, from = 0, state) => {
    const { trips = [], total = 0 } = await getParentTripsCreatedByStateAPI(
      limit,
      from,
      state
    );
    setTripsData({
      total,
      items: trips,
    });
  };

  const handleChange = (_, newValue) => {
    history.push(`/app/parent-travels?state=${newValue}`);
  };

  const handlePreviewPage = () => {
    const newPage = page - 1;
    setPage(newPage);
    fetchData(numberList, numberList * newPage, activeTab.state);
  };

  const handleNextPage = () => {
    const newPage = page + 1;
    setPage(newPage);
    fetchData(numberList, numberList * newPage, activeTab.state);
  };

  function a11yProps(index) {
    return {
      id: `parent-trips-tab-${index}`,
      "aria-controls": `parent-trips-tabpanel-${index}`,
    };
  }

  const renderTripCard = (trip, index) => {
    if (value === 0) {
      return (
        <CardItemOfferTravel
          key={trip._id || index}
          onClick={() => {}}
          idTravel={trip._id}
          product={trip.product}
          userDador={trip.user_id_dc}
          postulations={trip.postulation_pending || 0}
          originName={trip.origin_site?.site_name}
          destinyName={trip.destiny_site?.site_name}
          withdrawDate={trip.withdraw_date}
          deliveryDate={trip.delivery_date}
          state="Pendientes"
          showId={trip.id_trip}
          btnIcon={<p className="text-secondary mb-0 text-center text-sm-left">Solo lectura</p>}
        />
      );
    }

    return (
      <CardItemTravelBasic
        key={trip._id || index}
        status={trip.status}
        trucksNumber={trip.trucks_number}
        trucks_number_accepted={trip.counterTripdetails}
        originName={trip.origin_site?.site_name}
        destinyName={trip.destiny_site?.site_name}
        userDador={trip.user_id_dc}
        product_type_name={trip.product?.product_type_name}
        withdrawDate={trip.withdraw_date}
        deliveryDate={trip.delivery_date}
        state={activeTab.label}
        idTrip={trip._id}
        showId={trip.id_trip}
        onClick={() => {}}
        btnIcon={<GoTriangleRight />}
      />
    );
  };

  return (
    <>
      <DivParentTabs>
        <TabsStyled
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          aria-label="parent trips tabs"
          scrollButtons="off"
          variant="scrollable"
        >
          {TAB_CONFIG.map((tab, index) => (
            <TabStyled key={tab.label} label={tab.label} {...a11yProps(index)} />
          ))}
        </TabsStyled>
      </DivParentTabs>
      <Container fluid>
        <Row>
          <Col md="12">
            {TAB_CONFIG.map((tab, index) => (
              <TabMaterialLog key={tab.label} value={value} index={index}>
                <ContainerList>
                  {tripsData.items.length ? (
                    tripsData.items.map((trip, idx) => renderTripCard(trip, idx))
                  ) : (
                    <DivEmpty>
                      {!spinner ? (
                        <h2 className="font-weight-bold h3 text-center">
                          {tab.empty}
                        </h2>
                      ) : null}
                    </DivEmpty>
                  )}
                </ContainerList>
              </TabMaterialLog>
            ))}
          </Col>
        </Row>
      </Container>
      <RowStyled>
        <Col md="12">
          <PaginationList
            items={tripsData.items}
            total={tripsData.total}
            currPage={page}
            handlePreviewPage={handlePreviewPage}
            handleNextPage={handleNextPage}
            numberList={numberList}
          />
        </Col>
      </RowStyled>
    </>
  );
}

export default ParentTravels;
